// eslint-disable-next-line
import { Component } from 'preact';
import { MOBILE_MAX_WIDTH_MEDIA_QUERY } from '../../consts';

export function WhetherMobileHOC(WrappedComponent) {
    return class WhetherMobile extends Component {
        state = {
            isMobile: false,
        };

        componentDidMount() {
            this.mql = window.matchMedia(MOBILE_MAX_WIDTH_MEDIA_QUERY);
            this.mql.addListener(this.handleMediaQueryWidth);
            this.handleMediaQueryWidth();
        }

        componentWillUnmount() {
            this.mql.removeListener(this.handleMediaQueryWidth);
        }

        handleMediaQueryWidth = ev => {
            const isMobile = ev
                ? ev.matches
                : window.matchMedia(MOBILE_MAX_WIDTH_MEDIA_QUERY).matches;

            this.setState({ isMobile });
        };

        render() {
            return <WrappedComponent {...this.state} {...this.props} />;
        }
    };
}
